import { app } from '../../app';
import { Controller } from './sp-constant-alert.controller';

/**
 * @example
 * <sp-alert options="$ctrl.spAlert"></sp-alert>
 *
 * @example
 * class Controller {
 *   $onInit() {
 *     this.spAlert = new SpAlert('success', 'global.messages.success')
 *   }
 * }
 */
app.component('spConstantAlert', {
    bindings: {options: '<'},
    controller: Controller,
    templateUrl: require('./sp-constant-alert.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-constant-alert/sp-constant-alert.component.js